import {
    CHANGE_FIELD,
    CHANGE_NEW_PREMIUM_STORE_SETTINGS,
    CHANGE_PREMIUM_SETTINGS_FORM_INFO_STATE,
    CHANGE_PS_TYPE,
    CHANGE_SOLICITOR_GROUP,
    CHANGE_WORKSOURCE,
    DISPLAY_ONLY_LIVE_PREMIUM_SETTINGS,
    FAILED_GET_ALL_PREMIUM_SETTINGS,
    FAILED_GET_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP,
    GET_ALL_PREMIUM_SETTINGS,
    GET_PREMIUM_SETTINGS_FOR_SOLICITOR_GROUP_AND_WORKSOURCE,
    LOGOUT,
    NEW_PREMIUM_SETTINGS_PROPERTIES,
    OPEN_MODAL,
    RECEIVE_BAD_REQUEST_PATCH_POLICY_SETTING,
    RECEIVE_BAD_REQUEST_POST_NEW_POLICY_SETTING,
    RECEIVE_GET_GROUP_WORK_SOURCES,
    RECEIVE_GET_WORK_SOURCES,
    RECEIVE_PATCH_RESPONSE_PREMIUM_SETTING,
    RECEIVE_POST_RESPONSE_NEW_PREMIUM_SETTING,
    RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES,
    RECEIVE_PREMIUM_SETTINGS_SCHEDULES,
    RECEIVE_PREMIUM_SETTINGS_STAGES,
    RECEIVE_SOLICITOR_GROUPS,
    RECEIVE_SUB_CASE_TYPES_PREMIUM_SETTINGS,
    RECEIVED_ALL_PREMIUM_SETTINGS,
    RECEIVED_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP,
    REQUEST_PATCH_PREMIUM_SETTING,
    REQUEST_POST_NEW_PREMIUM_SETTING,
    UPDATE_DISPLAYED_PREMIUM_SETTINGS,
    PREMIUM_SETTINGS_PAGE_SHIFT, PREMIUM_SETTINGS_GO_TO_PAGE,
    RECEIVE_PREMIUM_SETTINGS_STAGES_CHAIN,
    RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES_CHAIN, REQUEST_GET_SPECIFIC_PREMIUM_SETTING,
    RECEIVE_BAD_REQUEST_PREMIUM_SETTING_BY_ID, RECEIVE_PREMIUM_SETTINGS_BY_ID,
    RECEIVE_PREMIUM_SETTINGS_CASE_TYPES_CHAIN, RECEIVE_PREMIUM_SETTINGS_SUB_CASES_CHAIN, RECEIVE_DELETE_PREMIUM_SETTING,
    RECEIVE_BAD_REQUEST_DELETE_PREMIUM_SETTING, REQUEST_DELETE_PREMIUM_SETTING, REQUEST_PREMIUM_SETTINGS_STAGES,
    REQUEST_PREMIUM_SETTINGS_DAMAGES, FAILED_TO_GET_PREMIUM_SETTINGS_DAMAGES, FAILED_TO_GET_PREMIUM_SETTINGS_STAGES,
    GET_PREMIUM_SETTINGS_WITH_COMBINATION, RECEIVE_PREMIUM_SETTINGS_WITH_COMBINATION,
    FAILED_TO_GET_PREMIUM_SETTINGS_WITH_COMBINATION, GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION,
    RECEIVE_ALL_PREMIUM_SETTINGS_WITH_COMBINATION, FAILED_TO_GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION,
    RECEIVE_SOLICITOR_GROUP_CASE_TYPES, RECEIVE_GET_SOLICITOR_GROUP_WORKSOURCES
} from "../actions/index";
import _ from "lodash";
import moment from "moment";
import {GET_SOLICITOR_GROUP_CASE_TYPES, REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES} from "../actions";

const defaultState = {
	fetchingPremiumWithCombination:false,
	fetchedPremiumWithCombination:[],
	fetchingAllPremiumsWithCombination:false,
	showTable: false,
	showAllPremiumSettingsForCombination: false,
	allPremiumSettingsForCombination: [],
	selectedCaseType: '',
	selectedSubCaseType: '',
	premium_settings: [],
	premiumSettingsCount: 0,
	page: 1,
	displayAmount: 20,
	fetching: false,
	value: 10,
	displayOnlyLive: false,
	newPremiumSettingsProperties: [],
	solicitorGroups: [],
	allWorksources: [],
	worksources: [],
	viewSolicitors: false,
	groupAgents: [],
	selectedSolicitorGroup: '',
	selectedWorksource: '',
	psType: 'default',
	openModal: false,
	allCaseTypes: [],
	groupCaseTypes: [],
	allSubCaseTypes: [],
	groupSubCaseTypes: [],
	posting: false,
	formData: {
		id: '',
		caseType: '', //caseTypeId
		subCaseType: '',//subCaseTypeId
		stage: '',
		validFrom: '',
		limitOfIndemnity: '',
		premium: '',
		recoverable: '',
		nonRecoverable: '',
		underwriterRate: '',
		underwriterRatePercentage: '',
		commission: '',
		commissionPercentage: '',
		coverRestrictions: '',
		schedule: '',
		scheduleType: '',
		scheduleComments: '',
		notes: ''
	},
	infoFields: {
		validFrom: false,
		limitOfIndemnity: false,
		premium: false,
		recoverable: false,
		nonRecoverable: false,
		underwriterRate: false,
		commission: false,
		scheduleComments: false,
		notes: false,
	},
	responseMsg: '',
	badResponseMsg: '',
	// damages: [],
	stages: [],
	schedules: [],
	scheduleTypes: [],
	selectedDamages: [],
	checkedDamagesIds: [],
	selectedPremiumSetting: {},
	patching: false,
	fetchingPremiumSettingById: false,
	openDeleteModal:false,
	premiumSettingSelectedToDelete: '',
	deleteResponseMsg: '',
	deleting:false,
	emptyPremiumSettings: '',
	fetchingDamages: false,
	fetchingStages: false,
	selectedSolicitorGroupName: '',
    editingPremiumSettingId: '',
	// Mirrors selectedSolicitorGroupName so the read-only selected-group label
	// in the wizards can show the group's ARAG Provider colour indicator once past the picker step.
	selectedSolicitorGroupAragProvider: null,
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES:
			return {
				...state,
                worksources: defaultState.worksources
			};
		case GET_SOLICITOR_GROUP_CASE_TYPES:
			return {
				...state,
                groupCaseTypes: defaultState.groupCaseTypes
			};
		case RECEIVE_GET_SOLICITOR_GROUP_WORKSOURCES:
			return {
				...state,
                worksources: action.payload
			};
		case RECEIVE_SOLICITOR_GROUP_CASE_TYPES:
			let sc = [];
			_.forEach(action.payload, cType => {
				_.forEach(cType.subCaseTypes, sCase => {
					sc.push(sCase)
				})
			});
			return {
				...state,
				groupCaseTypes: action.payload,
				groupSubCaseTypes: sc
			};
		case GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION:
			return {
				...state,
				fetchingAllPremiumsWithCombination: true
			};
		case RECEIVE_ALL_PREMIUM_SETTINGS_WITH_COMBINATION:
			return {
				...state,
				fetchingAllPremiumsWithCombination: false,
				allPremiumSettingsForCombination: action.payload
			};
		case FAILED_TO_GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION:
			return {
				...state,
				fetchingAllPremiumsWithCombination: false,
				badResponseMsg: action.payload
			};
		case GET_PREMIUM_SETTINGS_WITH_COMBINATION:
			return {
				...state,
				fetchingPremiumWithCombination: true,
			};
		case RECEIVE_PREMIUM_SETTINGS_WITH_COMBINATION:
			return {
				...state,
				fetchingPremiumWithCombination: false,
				showTable: action.payload? true: false,
                editingPremiumSettingId: action.payload? action.payload.id: '',
				fetchedPremiumWithCombination:action.payload? action.payload: []
			};
		case FAILED_TO_GET_PREMIUM_SETTINGS_WITH_COMBINATION:
			return {
				...state,
				fetchingPremiumWithCombination: false
			};
		case REQUEST_DELETE_PREMIUM_SETTING:
			return {
				...state,
				deleting:true
			};
		case RECEIVE_DELETE_PREMIUM_SETTING:
			for (let i = 0; i < state.premium_settings.length; i++) {
				if (state.premium_settings[i].id === state.premiumSettingSelectedToDelete) {
					let newPremium_settings = [...state.premium_settings];
					newPremium_settings.splice(i, 1);
					return {
						...state,
						patching: false,
						openDeleteModal:false,
						premiumSettingSelectedToDelete: '',
						deleting:false,
						premium_settings: newPremium_settings,
						premiumSettingsCount: newPremium_settings.length,
					}
				}
			}
			return {
				...state,
				openDeleteModal:false,
				premiumSettingSelectedToDelete: '',
				deleting:false
			};
		case RECEIVE_BAD_REQUEST_DELETE_PREMIUM_SETTING:
			return {
				...state,
				deleteResponseMsg: action.payload.response.body.message,
				deleting:false
			};
		case REQUEST_GET_SPECIFIC_PREMIUM_SETTING:
			return {
				...state,
				fetchingPremiumSettingById: true

			};
		case RECEIVE_BAD_REQUEST_PREMIUM_SETTING_BY_ID:
			return {
				...state,
				fetchingPremiumSettingById: false
			};
		case RECEIVE_PREMIUM_SETTINGS_BY_ID:
			return {
				...state,
				formData: {
					...state.formData,
					id: action.payload.id,
					caseType: action.payload.caseTypeId?action.payload.caseTypeId:'',
					subCaseType: action.payload.subCaseTypeId?action.payload.subCaseTypeId:'',
					stage: action.payload.stageId?action.payload.stageId:'',
					validFrom: action.payload.validFrom,
					limitOfIndemnity: action.payload.limitOfIndemnity,
					premium: action.payload.premium,
					recoverable: action.payload.recoverable?action.payload.recoverable:'',
					nonRecoverable: action.payload.nonRecoverable?action.payload.nonRecoverable:'',
					underwriterRate: action.payload.underwriterRate,
					underwriterRatePercentage: action.payload.underwriterRatePercentage,
					recoverableRatePercentage: action.payload.premiumSettings.recoverableRatePercentage,
					commission: action.payload.commission?action.payload.commission:'',
					commissionPercentage: action.payload.commissionPercentage?action.payload.commissionPercentage:'',
					coverRestrictions: action.payload.coverRestrictions?action.payload.coverRestrictions:'',
					schedule: action.payload.scheduleId,
					scheduleName: action.payload.scheduleName,
					scheduleType: action.payload.scheduleTypeId,
					scheduleTypeName: action.payload.scheduleTypeName,
					scheduleComments: action.payload.scheduleComments?action.payload.scheduleComments:'',
					notes: action.payload.notes?action.payload.notes:''
				},
				selectedDamages: action.payload.damageses?action.payload.damageses:[],
				checkedDamagesIds: action.payload.damageses?action.payload.damageses.map(i => i.id): [],
				fetchingPremiumSettingById: false
			};
		// case RECEIVE_PREMIUM_SETTINGS_DAMAGES_CHAIN:
		// 	return {
		// 		...state,
		// 		damages: _.sortBy(action.payload.damages, ['sortOrder'])
		// 	};
		case RECEIVE_PREMIUM_SETTINGS_CASE_TYPES_CHAIN:
			return {
				...state,
				allCaseTypes: action.payload.caseTypes
			};
		case RECEIVE_PREMIUM_SETTINGS_SUB_CASES_CHAIN:
			return {
				...state,
				allSubCaseTypes: action.payload.subCaseTypes
			};
		case RECEIVE_PREMIUM_SETTINGS_STAGES_CHAIN:
			return {
				...state,
				stages: action.payload.stages
			};
		// case RECEIVE_PREMIUM_SETTINGS_SOLICITOR_CHAIN:
		// 	return {
		// 		...state,
		// 		schedules: action.payload.schedules
		// 	};
		case RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES_CHAIN:
			return {
				...state,
				scheduleTypes: action.payload
			};
		case REQUEST_PATCH_PREMIUM_SETTING:
			return {
				...state,
				patching: true
			};
		case RECEIVE_PATCH_RESPONSE_PREMIUM_SETTING:
			for (let i = 0; i < state.premium_settings.length; i++) {
				if (state.premium_settings[i].id === action.payload.id) {
					let newPremium_settings = [...state.premium_settings];
					if (i !== 0) {
						newPremium_settings[i] = action.payload;
					}
					else {
						newPremium_settings[0] = action.payload;
					}
					return {
						...state,
						patching: false,
						responseMsg: 'Premium setting was updated successfully.',
						premium_settings: newPremium_settings
					}
				}
			}
			return {
				...state,
				patching: false,
				responseMsg: 'Premium setting was updated successfully.'
			};
		case RECEIVE_BAD_REQUEST_PATCH_POLICY_SETTING:
			return {
				...state,
				patching: false,
				badResponseMsg: action.payload.response.body.message
			};
		case REQUEST_PREMIUM_SETTINGS_DAMAGES:
			return {
				...state,
				fetchingDamages: true
			};
		// case RECEIVE_PREMIUM_SETTINGS_DAMAGES:
		// 	return {
		// 		...state,
		// 		damages: _.sortBy(action.payload, ['sortOrder']),
		// 		fetchingDamages: false
		// 	};
		case FAILED_TO_GET_PREMIUM_SETTINGS_DAMAGES:
			return {
				...state,
				fetchingDamages: false
			};
		case REQUEST_PREMIUM_SETTINGS_STAGES:
			return {
				...state,
				fetchingStages: true
			};
		case RECEIVE_PREMIUM_SETTINGS_STAGES:
			return {
				...state,
				stages: action.payload,
				fetchingStages: false
			};
		case FAILED_TO_GET_PREMIUM_SETTINGS_STAGES:
			return {
				...state,
				fetchingStages: false
			};
		case RECEIVE_PREMIUM_SETTINGS_SCHEDULES:
			return {
				...state,
				schedules: action.payload
			};
		case RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES:
			return {
				...state,
				scheduleTypes: action.payload
			};
		case REQUEST_POST_NEW_PREMIUM_SETTING:
			return {
				...state,
				posting: true
			};
		case RECEIVE_POST_RESPONSE_NEW_PREMIUM_SETTING: {
			return {
				...state,
				premium_settings: [action.payload, ...state.premium_settings],
				premiumSettingsCount: [action.payload, ...state.premium_settings].length,
				posting: false,
				responseMsg: 'New premium setting was created successfully.',
				formData: defaultState.formData,
				selectedDamages: defaultState.selectedDamages,
				checkedDamagesIds: defaultState.checkedDamagesIds,
			};
		}
		case RECEIVE_BAD_REQUEST_POST_NEW_POLICY_SETTING: {
			return {
				...state,
				posting: false,
				badResponseMsg: action.payload
			};
		}
		case CHANGE_FIELD:
			return {
				...state,
				openModal: false
			};
		case CHANGE_NEW_PREMIUM_STORE_SETTINGS:
			if(action.payload.key === 'selectedCaseType'){
				return {
					...state,
					[action.payload.key]: action.payload.value,
					selectedSubCaseType: '',
					showTable: false,
                    showAllPremiumSettingsForCombination: false,
                    allPremiumSettingsForCombination:[]
				}
			}
			if(action.payload.key === 'selectedSolicitorGroup')
				return {
					...state,
					[action.payload.key]: action.payload.value,
					premium_settings: defaultState.premium_settings,
					premiumSettingsCount: defaultState.premiumSettingsCount,
					page: defaultState.page,
					displayAmount: defaultState.displayAmount,
					fetching: defaultState.fetching,
					displayOnlyLive: defaultState.displayOnlyLive,
					showTable: false,
                    showAllPremiumSettingsForCombination: false,
                    allPremiumSettingsForCombination: []
				};
            if(action.payload.key !== 'showAllPremiumSettingsForCombination')
                return {
                    ...state,
                    [action.payload.key]: action.payload.value,
                    showTable: false,
                    showAllPremiumSettingsForCombination: false,
                    allPremiumSettingsForCombination: []
                };
			return {
				...state,
				[action.payload.key]: action.payload.value,
				emptyPremiumSettings: '',
				showTable: false
			};
		case RECEIVE_SUB_CASE_TYPES_PREMIUM_SETTINGS:
			return {
				...state,
				allSubCaseTypes: action.payload
			};
		case CHANGE_PREMIUM_SETTINGS_FORM_INFO_STATE:
			return {
				...state,
				infoFields: {
					...state.infoFields,
					[action.payload.key]: !state.infoFields[action.payload.key]
				}
			};
		case GET_PREMIUM_SETTINGS_FOR_SOLICITOR_GROUP_AND_WORKSOURCE:
			return {
				...state,
				fetching: true,
			};
		case RECEIVED_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP:
			return {
				...state,
				premium_settings: action.payload,
				premiumSettingsCount: action.payload.length,
				fetching: false,
				emptyPremiumSettings: action.payload.length === 0? 'No premium settings for this combination exists.':''
			};
		case FAILED_GET_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP:
			return {
				...state,
				fetching: false
			};
		case GET_ALL_PREMIUM_SETTINGS:
			return {
				...state,
				fetching: true,
			};
		case RECEIVED_ALL_PREMIUM_SETTINGS:
			return {
				...state,
				premium_settings: action.payload,
				premiumSettingsCount: action.payload.length,
				fetching: false,
			};
		case FAILED_GET_ALL_PREMIUM_SETTINGS:
			return {...state};
        case DISPLAY_ONLY_LIVE_PREMIUM_SETTINGS:
            return {
                ...state,
                displayOnlyLive: !state.displayOnlyLive,
            };
        case UPDATE_DISPLAYED_PREMIUM_SETTINGS:
            return {
                ...state,
                displayAmount: action.payload,
            };
        case RECEIVE_SOLICITOR_GROUPS:
            return {
                ...state,
                solicitorGroups: action.payload.data
			};
        case RECEIVE_GET_WORK_SOURCES:
            return {
                ...state,
                allWorksources: action.payload
            };
        case RECEIVE_GET_GROUP_WORK_SOURCES:
            return {
                ...state,
                worksources: action.payload
            };
        case NEW_PREMIUM_SETTINGS_PROPERTIES:
            //TODO
            let newProperty = (action.payload.property);
            let indexSetting = _.findIndex(state.newPremiumSettingsProperties, x => x.property.indexOf(newProperty));
            if (indexSetting === -1) {
                return {
                    ...state,
                    newPremiumSettingsProperties: [...state.newPremiumSettingsProperties, action.payload],
                }
            } else {
                state.newPremiumSettingsProperties[indexSetting] = action.payload;
                return {
                    ...state,
                    newPremiumSettingsProperties: state.newPremiumSettingsProperties
                }
            }
        case CHANGE_PS_TYPE:
            return {
                ...state,
                psType: action.payload,
                premium_settings: defaultState.premium_settings,
                premiumSettingsCount: defaultState.premiumSettingsCount,
                emptyPremiumSettings: '',
                selectedCaseType: '',
                selectedSubCaseType: '',
                selectedSolicitorGroup: '',
                selectedWorksource: '',
                selectedSolicitorGroupName: '',
                selectedWorksourceName: '',
                showAllPremiumSettingsForCombination: false,
                allPremiumSettingsForCombination: [],
				showTable: false,
                // Reset alongside selectedSolicitorGroupName - both describe the same no-longer-
                // selected group, so leaving the old aragProvider behind would show a stale colour
                // indicator for a group name that's now blank.
                selectedSolicitorGroupAragProvider: null,
            };
        case OPEN_MODAL:
            return {
                ...state,
                openModal: action.payload
            };
        case CHANGE_SOLICITOR_GROUP:
            let checkIndex = parseInt(action.payload.target.value);
            let index = _.findIndex(state.solicitorGroups, x => x.id === checkIndex);
            let seekWorkSources = state.solicitorGroups[index].workSource.map((item) => {
                let allIndex = _.findIndex(state.allWorksources, x => x.id === item)
                return state.allWorksources[allIndex];
            });
            return {
                ...state,
                selectedSolicitorGroup: action.payload.target.value,
                worksources: seekWorkSources
            };
        case CHANGE_WORKSOURCE:
            let workSource = _.find(state.allWorksources, worksource => {return worksource.id.toString() === action.payload.target.value});
            return {
                ...state,
                selectedWorksource: action.payload.target.value,
                selectedWorksourceName: workSource?workSource.name:'',
                emptyPremiumSettings: '',
                premium_settings: defaultState.premium_settings,
                premiumSettingsCount: defaultState.premiumSettingsCount,
                page: defaultState.page,
                displayAmount: defaultState.displayAmount,
                fetching: defaultState.fetching,
                displayOnlyLive: defaultState.displayOnlyLive
            };
        // case RECEIVE_GET_CASE_TYPES:
        //     return {
        //         ...state,
        //         allCaseTypes: action.payload
        //     };
        case PREMIUM_SETTINGS_PAGE_SHIFT:
            if (action.payload.direction === 'left' && state.page > 1)
                return {
                    ...state,
                    page: state.page - 1,
                    totalBoxes: action.payload.totalPaginationBoxes
                };
            else if (action.payload.direction === 'right' && state.page < state.totalBoxes)
                return {
                    ...state,
                    page: state.page + 1,
                    totalBoxes: action.payload.totalPaginationBoxes
                };
            else return {
                    ...state,
                    totalBoxes: action.payload.totalPaginationBoxes
                };
        case PREMIUM_SETTINGS_GO_TO_PAGE:
            return {
                ...state,
                page: action.payload
            };
        case LOGOUT:
            return {
                ...defaultState
            };
		case '@@router/LOCATION_CHANGE':
			if (action.payload.location.pathname.includes('/premium-settings/edit-premium-settings') ||
				(action.payload.location.pathname === '/premium-settings/new-premium-settings') ||
				(action.payload.location.pathname === '/premium-settings/new-staged-premium-settings') ||
				(action.payload.location.pathname.includes('/premium-settings/edit-staged-premium-settings')))
				return {
					...state,
					selectedPremiumSetting: (action.payload.location.pathname.includes('/premium-settings/edit-premium-settings')) ? state.selectedPremiumSetting : defaultState.selectedPremiumSetting,
					showTable: (action.payload.location.pathname.includes('premium-settings') && state.selectedCaseType != '' && !_.isEmpty(state.fetchedPremiumWithCombination)) ? true : false,
					fetchedPremiumWithCombination: (action.payload.location.pathname.includes('premium-settings') && state.selectedCaseType != '') ? state.fetchedPremiumWithCombination : [],
				};
				
			const isRedirection = action.payload.location.state?.isRedirection ?? false;
			if (action.payload.location.pathname.includes('/premium-settings') && isRedirection)
				return {
					...defaultState,
					psType: state.psType
				};
			if (!action.payload.location.pathname.includes('/premium-settings') || action.payload.action != 'POP' || (action.payload.action === 'POP' && action.payload.isFirstRendering))
				return {
					...defaultState,
				};
			return {
				...state,
				selectedPremiumSetting: (action.payload.location.pathname.includes('/premium-settings/edit-premium-settings')) ? state.selectedPremiumSetting : defaultState.selectedPremiumSetting,
				showTable: (action.payload.location.pathname.includes('premium-settings') && state.selectedCaseType != '' && !_.isEmpty(state.fetchedPremiumWithCombination)) ? true : false,
				fetchedPremiumWithCombination: (action.payload.location.pathname.includes('premium-settings') && state.selectedCaseType != '' ) ? state.fetchedPremiumWithCombination : [],
			};
        default :
            return state
    }
}
